import { Image as ImageItem } from "utils/api/client/types/types"

export class Image {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  create(
    body: unknown,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<ImageItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events/image`, {
        method: "POST",
        headers: {
          ...headers,
          "content-type": null,
        },
        body,
        query,
      })
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events/image/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }
}
